<template>
	<modal
		ref="modal"
		@show="show"
		modal-class="modal-booking"
		:body-class="{
			'py-md-3 px-md-6': step != 3,
			'py-md-3': step == 3,
		}"
		v-bind="$attrs"
		:size="size"
	>
		<div
			class="my-5 text-center"
			v-if="booking.loading"
		>
			<loader />
		</div>

		<transition-group name="slide-down">
			<booking-form
				key="form"
				v-if="!submitted && booking.init"
				ref="form"
				@closed="$refs.modal.close()"
			/>

			<booking-achieved
				key="submitted"
				v-if="submitted"
			/>
		</transition-group>

		<template #footer>
			<transition name="slide-up">
				<div
					v-if="booking.init"
					class="row w-100"
				>
					<div
						v-if="!submitted"
						class="col-md-12 d-flex align-items-center justify-content-between"
					>
						<div class="col-md-3">
							<button
								key="back"
								@click="prev()"
								v-if="step != 0"
								class="btn btn-outline-primary"
							>
								{{ $t("account/bookings.Back") }}
							</button>
						</div>
						<!-- /.col -->

						<div class="col-md-6">
							<booking-progress />
						</div>
						<!-- /.col -->

						<div class="col-md-3 text-right">
							<div
								v-if="step == 3"
								@show="() => isDisableBooking()"
							>
								<loading-button
									@click="submit()"
									:disabled="isDisableBooking()"
									:loading="loading"
									class="btn btn-primary ms-5"
								>
									{{ $t("account/bookings.Book") }}
								</loading-button>
							</div>

							<button
								@click="next()"
								v-else
								class="btn btn-primary ms-5"
							>
								{{ $t("account/bookings.Next") }}
							</button>
						</div>
						<!-- /.col -->
					</div>
					<!-- /.col -->

					<div
						v-if="submitted"
						class="ml-auto d-flex justify-content-end"
					>
						<button
							@click="$refs.modal.close()"
							class="btn btn-neutral"
						>
							{{ $t("account/bookings.Close") }}
						</button>
					</div>
				</div>

				<!-- /.row -->
			</transition>
		</template>
	</modal>
</template>

<script>
	import { v4 as uuidv4 } from "uuid"
	import { mapState, mapGetters } from "vuex"
	import BookingForm from "@components/booking/Form"
	import BookingProgress from "@components/booking/Progress"
	import BookingAchieved from "@components/booking/Achieved"

	export default {
		data() {
			return {
				loading: false,
			}
		},

		components: {
			BookingForm,
			BookingProgress,
			BookingAchieved,
		},

		props: {
			data: {
				type: Object,
				default: () => {},
			},
		},

		computed: {
			...mapState({
				booking: state => state.booking,
				step: state => state.booking.step,
				submitted: state => state.booking.submitted,
			}),

			...mapGetters("booking", ["progress"]),

			size() {
				return this.booking.submitted ? "lg" : "xl"
			},
		},

		methods: {
			isFormComplete() {
				return this.progress == 100
			},

			isDisableBooking() {
				return this.isFormComplete() ? false : true
			},

			open() {
				this.$refs.modal.open()
				this.$store.dispatch("booking/initBooking").then(response => {
					const isIntermediary = this.data.isIntermediary
					if (isIntermediary) {
						this.$store.commit("booking/setClients", this.data.clients)
						this.$store.commit("booking/setClientIntermediary", isIntermediary)
					} else {
						this.$store.commit("booking/setClient", this.data.client)
					}
				})
			},

			show() {
				this.$emit("show")
			},

			prev() {
				this.$refs.form.setStep(this.booking.step - 1)
			},

			next() {
				this.$refs.form.setStep(this.booking.step + 1)
			},

			submit() {
				this.loading = true

				this.$store
					.dispatch("booking/saveBooking")
					.then(response => {
						this.loading = false
					})
					.catch(error => {
						this.$flash(this.$t("app.An error has occured"))
						this.loading = false
					})
			},
		},

		mounted() {
			window.i18n.locale = this.data.locale
			this.$store.commit("lang/setLang", this.data.locale)
			this.$store.commit("lang/setLangs", this.data.langs)
			window.moment.locale(this.data.locale)
		},
	}
</script>
